import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { LocalStorageSettingsService } from './../../shared/services/local-storage-settings.service';
import { validationmethod } from 'src/app/shared/common/validationmethod';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { EtlService } from '../vault-data-migration-etl/etl.service';


@Component({
    selector: 'app-etob-popup',
    templateUrl: './etob-popup.component.html',
    styleUrls: ['./etob-popup.component.scss'],
    standalone: false
})
export class EtobPopupComponent implements OnInit {

  FormValid: UntypedFormGroup;
  backgroundColorButton = "";
  backgroundColorScreen="";
  buttonColor="";
  statevaluechange={"fileName":"","fileData":""}
  imagephotoshow: any = false;
  imagephoto;
  selectedType = [];
  selectedOperation = [];
  selectedobjectName = [];
  validation_messages;
  taskDetails={"type":"", "objectName":"", "operation":""};
  imageName
  imageupload
  type
  object
  operation
  allocateButtonsBoolean
  allocateButtons1Boolean
  migrationType = "E2B";
  migrationDataLoadLogObject: any = [];
  mgrstartdt : any;
  mgrid: any;
  mgrstatus: any;

  constructor(private dialogref: MatDialogRef<EtobPopupComponent>, private localStorageSettings: LocalStorageSettingsService, private snackbar: MatSnackBar, private service:EtlService, private spinner: NgxUiLoaderService, private msg: ErrorMessages,private validation: validationmethod) { 
    this.validation_messages = this.msg.E2B;

  }

  ngOnInit() {

    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");

    this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");

    this.formvalidations();
    this.selectedType = [
      "E2B", "Library", "Non-E2B", "Document Attachments"
    ];
    this.selectedOperation = [
      "Insert", "Update", "Delete"
    ];
    this.retrieveObjectName();
    this.retrieveMigrationLog();

  }

  formvalidations() {
    this.FormValid = new UntypedFormGroup({
      imageName: new UntypedFormControl(""),
      imageupload: new UntypedFormControl(""),
      type: new UntypedFormControl(this.selectedType),
      object: new UntypedFormControl(this.taskDetails.objectName),
      operation: new UntypedFormControl(this.selectedOperation)
    });
  }

  retrieveMigrationLog(){
    this.spinner.start();
    this.service.retrieveMigrationDatalog(this.localStorageSettings.getSettings("dnsName")).subscribe(response => {

      console.log(response)

      if (response.error == true) {

        this.snackbar.open(response.statusMessage, "Ok", { duration: 5000 });

        this.spinner.stop();

      }

      else {

        this.migrationDataLoadLogObject = response;

        console.log(this.migrationDataLoadLogObject);

        this.mgrstatus = "";
        this.mgrstartdt = "";
        this.mgrid = "";

          for(let i=0;i<this.migrationDataLoadLogObject.length;i++){ 
            if(this.migrationDataLoadLogObject[i].state === "In Progress"){
              this.mgrstatus = this.migrationDataLoadLogObject[i].state;
              this.mgrstartdt = this.migrationDataLoadLogObject[i].startdt;
              this.mgrid = this.migrationDataLoadLogObject[i].migrationId;
              console.log(this.migrationDataLoadLogObject);
            }
            if(this.mgrstatus != "In Progress"){
              this.mgrstatus = "Migration is not in progress";
            }

            console.log(this.mgrid);

        }

        this.spinner.stop();
        
      }

    });
  }

  readThisimage(inputValue: any,filecheck:any): void {
    let ischeckfile=false
   var file: File = inputValue.files[0];
   var FileS: File = inputValue.files[0];
   console.log(file.type)
   if(filecheck==='csv'){
     if (file.type === 'text/csv' || file.type ==='application/vnd.ms-excel'){
       ischeckfile=true
     }
   }
   if (ischeckfile) {

     console.log(file.size / 1000)
     var size = file.size / 1000
     if (size <= 25072) {
           var fileName = FileS.name;
           //var filename = (<HTMLInputElement>document.getElementById('file-id')).value;

           var photo: FileReader = new FileReader();
            photo.onloadend = e => {
             var img = photo.result;
             console.log(photo.result);
             var photobase64result = photo.result.toString().split(",", 2)[1];

             // this is to check the file is empty or not
               this.imagephoto = photo.result.toString();
               this.imagephotoshow = true;
               this.statevaluechange.fileData = photobase64result;
               this.statevaluechange.fileName = fileName;
               this.FormValid.controls.imageName.setValue(fileName);
               console.log(this.statevaluechange)
               // (<HTMLInputElement>document.getElementById('file-path')).value= fileName;
             
           };
               photo.readAsDataURL(file);
     } else {
       this.snackbar.open("Selected image " + file.name + ", size should be less than 3MB", "OK", {
         duration: 5000,
       });
     }
   } else {
     this.snackbar.open(file.name + "is invalid file. Please select CSV file ", "OK", {
       duration: 5000,
     });
   }
 }

  fileupload($event,filecheck): void {
    this.readThisimage($event.target,filecheck);
  }

  typeSelection(event){
    console.log(event.value);
    this.taskDetails.type = event.value
  }

  objectSelection(e){
    console.log(e.value);
    this.taskDetails.objectName = e.value;
  }
  operationSelection(e){
    console.log(e.value);
    this.taskDetails.operation = e.value;
  }

  retrieveObjectName(){
    this.service.retrieveetobobjects(this.localStorageSettings.getSettings("dnsName")).subscribe(res=>{
      console.log(res)
      this.selectedobjectName = res;
      console.log(this.selectedobjectName);
      console.log(this.selectedobjectName[0].objectName);
      this.taskDetails.objectName = this.selectedobjectName[0].objectName;
    });
  }

  loadFile(){
    if(!this.FormValid.valid){
      // displaying validation message.
      this.validation.validateAllFormFields(this.FormValid);

      this.validation.getvalidationmessage();
      console.log(this.taskDetails.type);
      console.log(this.taskDetails.operation);
    }
    else{

      let addTask = {
        "file":this.statevaluechange.fileData,
        "fileName":this.statevaluechange.fileName,
        "activity": this.taskDetails.type,
        "objectName":this.taskDetails.objectName,
        "operation":this.taskDetails.operation,
        "migrationid":this.mgrid
      }
      this.spinner.start();
      console.log(addTask);

      this.service.insertetobtask(this.localStorageSettings.getSettings("vaultDnsname"),this.localStorageSettings.getSettings("dnsName"),addTask).subscribe(response =>{
        console.log(response);
        // checking if response is true or not
        if (response.error == true) {
          this.spinner.stop();
          this.snackbar.open(response.statusMessage, "OK", {
            duration: 5000,
          });
   
        } else {
          this.spinner.stop();
          console.log(response)
          this.snackbar.open(response.statusMessage, "OK", {
            duration: 5000,
          });
          this.cancel();
          this.formvalidations();   
        }
        this.spinner.stop();
      });
    }
  }

  cancel() {
    // this.selectedVaultObjects=[];
    this.formvalidations()
    this.dialogref.close();
  }

}
